module.exports = __webpack_public_path__ + "static/media/perform_with_ibacos.b11cff4a.svg";